/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import classname from 'classnames';
import * as React from 'react';
import { ILogo14HandsData } from './logo-14hands.data';
import { dataSvg } from './logo-14hands.data-logo';
import { ILogo14handsConfig, ILogo14handsProps } from './logo-14hands.props.autogenerated';

// ==============================================================================
// Interfaces
// ==============================================================================
interface IDataSvgPath {
    hover: boolean;
    d: string;
}

// ==============================================================================
/**
 * Logo14hands component
 * @extends {React.PureComponent<ILogo14handsProps<ILogo14handsData>>}
 */
// ==============================================================================
class Logo14hands extends React.PureComponent<ILogo14handsProps<ILogo14HandsData>> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const { config } = this.props;

        return (
            <div className={classname('logo-14hands', config.className)} >
                {this._renderLogo(config)}
            </div>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderLogo(config: ILogo14handsConfig):JSX.Element {
        if (config.link && config.link.linkUrl.destinationUrl) {
            return (
                <a href={config.link.linkUrl.destinationUrl} aria-label={config.link.ariaLabel}>
                    {this._renderSvg()}
                </a>
            );
        } else {
            return this._renderSvg();
        }
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderSvg():JSX.Element {
        return (
            <svg className='logo-14hands-svg' viewBox={dataSvg.viewBox}>
                {dataSvg.paths.map((path: IDataSvgPath, index: number) =>
                    <path
                        className={classname('logo-14hands-path', this._getActivePath(path.hover))}
                        key={index}
                        d={path.d}
                    />
                )}
            </svg>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _getActivePath(hover: boolean): string | null {
        return hover ? 'logo-14hands-path-active' : null;
    }
}

export default Logo14hands;